import { ReactElement } from 'react';
import { Skeleton } from 'newcomponents/UI/Skeleton';

const skeletonStyles = {
  wrapper: {
    width: '100%',
    height: 44,
    margin: 0,
    alignItems: 'center',
    borderRadius: 6,
    display: 'flex',
    padding: '8px 12px',
    border: '1px solid var(--v3-black-15)',
    backgroundColor: 'var(--v3-black-0)'
  },
  title: { width: 81, height: 28, margin: 0 },
  arrow: { width: 14, height: 14, margin: 0, borderRadius: 50 }
};

export const ProvidersSkeleton = (): ReactElement => {
  return (
    <div style={skeletonStyles.wrapper}>
      <Skeleton
        title={{ style: skeletonStyles.title }}
        paragraph={false}
        active
      />

      <div style={{ width: 14 }}>
        <Skeleton
          title={{ style: skeletonStyles.arrow }}
          paragraph={false}
          active
        />
      </div>
    </div>
  );
};
